// extracted by mini-css-extract-plugin
export default {"mobileContainer":"aJ0RFP","overlay":"aKMGf4","svgContainer":"vS3y_p"};